import { get, isUndefined } from 'lodash-es'
import { DEFAULT_LOCALE_KEY, LOCALE_KEY, LOCALE_STORE_KEY } from '@/constant/cache-key'
import { loadStorage } from '@/utils/cache'

// 翻译通用hooks，用于获取翻译文本
export function useTranslate() {
  // 当前的语言环境
  const locale = computed(() => loadStorage(LOCALE_KEY, DEFAULT_LOCALE_KEY))

  // 当前翻译的信息数据
  const localesStoreRef = computed(() => loadStorage(LOCALE_STORE_KEY, {}))

  const message = computed(() => get(localesStoreRef.value, `locales.${locale.value}`, {}))

  /**
   * 多语言翻译方法
   * @example translate('common.hello', { name: 'Ray' })  ==> 你好，Ray / 多语言定义 common.hello: 你好，{name}
   * @example translate('common.hello')  ==> 你好 / 多语言定义 common.hello: 你好
   * @param path 多语言完整路径
   * @param props 多语言插槽参数，需要与多语言中的名称一致
   * @returns 翻译后的文本
   */
  function translate(path: string, props: Record<string, string> = {}) {
    let result = ''
    try {
      const langString: string = get(message.value, path, '')
      result = langString
      const matchResult = langString.match(/\{(\w+)\}/) || []
      const [, key = ''] = matchResult || []
      const value = get(props, key)
      if (key && value) {
        result = result.replace(/\{(\w+)\}/, value)
      }
    }
    catch (error) {
      console.error('translate error :>>', error)
    }
    return result
  }

  // 转义后端多语言字段方法
  function translateBackendData(source: unknown, key: string) {
    const suffix = locale.value === DEFAULT_LOCALE_KEY ? '' : 'Cn'
    const value = get(source, `${key}${suffix}`)

    if (isUndefined(value)) {
      return get(source, key) || '-'
    }

    return value || '-'
  }

  return {
    tbd: translateBackendData,
    translate,
  }
}
